import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BusquedaFuncionarioComponent } from './busqueda-funcionario.component';



const routes: Routes = [
  { path: '', component: BusquedaFuncionarioComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusquedaFuncionarioRoutingModule { }
